import React, { Dispatch, SetStateAction } from 'react'
import { User } from 'models/user'

const UserStateContext = React.createContext<User | undefined>(undefined)
const UserUpdaterContext = React.createContext<any | undefined>(undefined)

export const UserProvider: React.FC<{ defaultValue?: User }> = ({ children, defaultValue }) => {
  const [user, setUser] = React.useState<User | undefined>(defaultValue)

  return (
    <UserStateContext.Provider value={user}>
      <UserUpdaterContext.Provider value={setUser}>{children}</UserUpdaterContext.Provider>
    </UserStateContext.Provider>
  )
}

export function useUserProvider() {
  const context = React.useContext(UserStateContext)

  if (typeof context === undefined) {
    throw new Error('useUserState must be used within a UserProvider')
  }

  return context
}

export function useUserUpdater() {
  const setUser = React.useContext(UserUpdaterContext)

  if (typeof setUser === undefined) {
    throw new Error('useUserUpdater must be used within a UserProvider')
  }

  return React.useCallback((user) => setUser(new User(user)), [setUser])
}

type UserContextType = [User | undefined, Dispatch<SetStateAction<User>>]
export const useUserContext = (): UserContextType => [useUserProvider(), useUserUpdater()]
